export interface PresenceColor {
  background: string;
  text: string;
}

// Theme-scoped variables in `styles.css`. Slot 0 is the design's leftmost avatar.
export const PRESENCE_COLORS: readonly PresenceColor[] = [0, 1, 2, 3, 4].map(
  slot => ({
    background: `var(--presence-${slot}-bg)`,
    text: `var(--presence-${slot}-text)`,
  })
);

export const PRESENCE_OVERFLOW_COLOR: PresenceColor = {
  background: 'var(--presence-overflow-bg)',
  text: 'var(--presence-overflow-text)',
};

export function presenceColorForSlot(slot: number): PresenceColor {
  return PRESENCE_COLORS[slot % PRESENCE_COLORS.length];
}

/** A user keeps their slot from `previous`. A newcomer takes the lowest free slot, so a leaver never recolors the others. */
export function assignPresenceSlots(
  userIds: readonly string[],
  previous: ReadonlyMap<string, number> = new Map()
): ReadonlyMap<string, number> {
  const slots = new Map<string, number>();
  for (const userId of userIds) {
    const slot = previous.get(userId);
    if (slot !== undefined) slots.set(userId, slot);
  }

  const taken = new Set(slots.values());
  let candidate = 0;
  for (const userId of userIds) {
    if (slots.has(userId)) continue;
    while (taken.has(candidate)) candidate++;
    slots.set(userId, candidate);
    taken.add(candidate);
  }
  return slots;
}
